module.exports = __webpack_public_path__ + "img/max-envelope-configure.a2c4dd1c.svg";